var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseSm = function SvgCloseSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    d: "M6.535 6.535a.97.97 0 0 1 1.375 0l7.09 7.09 7.09-7.09a.972.972 0 1 1 1.375 1.375L16.375 15l7.09 7.09a.972.972 0 1 1-1.375 1.375L15 16.375l-7.09 7.09a.972.972 0 1 1-1.375-1.375l7.09-7.09-7.09-7.09a.97.97 0 0 1 0-1.375",
    clipRule: "evenodd"
  }))));
};
export default SvgCloseSm;